export type ModuleCode =
  | "dashboard"
  | "clientes"
  | "facturacion"
  | "operaciones"
  | "control_lecturas"
  | "prestamos"
  | "documentacion_apr"
  | "bodega"
  | "reportes"
  | "configuracion"
  | "modulo_terreno";

const ROUTE_MODULE_RULES: Array<{ prefix: string; moduleCode: ModuleCode }> = [
  { prefix: "/configuracion", moduleCode: "configuracion" },
  { prefix: "/reportes", moduleCode: "reportes" },
  { prefix: "/lecturas", moduleCode: "control_lecturas" },
  { prefix: "/lecturas-periodo", moduleCode: "reportes" },
  { prefix: "/seguimiento-terreno", moduleCode: "reportes" },
  { prefix: "/bodega", moduleCode: "bodega" },
  { prefix: "/control-lecturas", moduleCode: "control_lecturas" },
  { prefix: "/prestamos", moduleCode: "prestamos" },
  { prefix: "/documentacion-apr", moduleCode: "documentacion_apr" },
  { prefix: "/operaciones", moduleCode: "operaciones" },
  { prefix: "/facturacion", moduleCode: "facturacion" },
  { prefix: "/registrar-pago", moduleCode: "facturacion" },
  { prefix: "/caja-chica", moduleCode: "facturacion" },
  { prefix: "/gastos-variables", moduleCode: "facturacion" },
  { prefix: "/clientes", moduleCode: "clientes" },
  { prefix: "/contratos", moduleCode: "clientes" },
  { prefix: "/notificaciones", moduleCode: "dashboard" },
  { prefix: "/administracion", moduleCode: "configuracion" },
  { prefix: "/modulo-terreno", moduleCode: "modulo_terreno" },
  { prefix: "/", moduleCode: "dashboard" },
];

const MODULE_HOME_ROUTE: Record<ModuleCode, string> = {
  dashboard: "/",
  clientes: "/clientes",
  facturacion: "/facturacion",
  operaciones: "/operaciones",
  control_lecturas: "/lecturas",
  prestamos: "/prestamos",
  documentacion_apr: "/documentacion-apr",
  bodega: "/bodega",
  reportes: "/reportes",
  configuracion: "/configuracion",
  modulo_terreno: "/modulo-terreno",
};

export const NAV_MODULE_ORDER: ModuleCode[] = [
  "dashboard",
  "clientes",
  "facturacion",
  "operaciones",
  "control_lecturas",
  "prestamos",
  "documentacion_apr",
  "bodega",
  "reportes",
  "configuracion",
  "modulo_terreno",
];

export function getModuleForPath(pathname: string): ModuleCode {
  const normalizedPath = pathname.trim() || "/";
  for (const rule of ROUTE_MODULE_RULES) {
    if (rule.prefix === "/") {
      return rule.moduleCode;
    }
    if (normalizedPath === rule.prefix || normalizedPath.startsWith(`${rule.prefix}/`)) {
      return rule.moduleCode;
    }
  }
  return "dashboard";
}

export function getFirstAllowedPath(modules: string[]): string {
  const moduleSet = new Set(modules.map((value) => value.trim().toLowerCase()));
  for (const moduleCode of NAV_MODULE_ORDER) {
    if (moduleSet.has(moduleCode)) {
      return MODULE_HOME_ROUTE[moduleCode];
    }
  }
  return "/";
}
